export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "package": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paquete"])},
            "crop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultivo"])},
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor(a)"])},
            "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organización"])},
            "package_group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallet"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
            "exporter_process_brand": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marca"])},
            "exporter_process_crop_category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoría"])},
            "exporter_process_crop_variety": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variedad"])},
            "exporter_process_crop_size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibre"])},
            "exporter_process_crop_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaque"])},
            "exporter_process_crop_package_value": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("name")), " de ", _interpolate(_named("weight")), " Kg"])},
            "packing_line": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Línea de empaque"])},
            "total_buy_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio de compra"])},
            "buy_price_per_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio de compra por paquete"])}
          }
        }
      },
      "en": {
        "model": {
          "package": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Package"])},
            "crop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop"])},
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producer"])},
            "organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organization"])},
            "package_group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallet"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity"])},
            "exporter_process_brand": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brand"])},
            "exporter_process_crop_category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
            "exporter_process_crop_variety": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variety"])},
            "exporter_process_crop_size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])},
            "exporter_process_crop_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Package"])},
            "exporter_process_crop_package_value": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("weight")), " Kg ", _interpolate(_named("name"))])},
            "total_buy_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total Buy Price"])},
            "buy_price_per_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buy price per package"])}
          }
        }
      }
    }
  })
}